import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-program-information-badge',
  templateUrl: './program-information-badge.component.html',
  styleUrls: ['./program-information-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [DividerModule],
})
export class ProgramInformationBadgeComponent {}
